import { combineReducers } from 'redux';
import getImages from './reducer_posts';

const rootReducer = combineReducers({
  images: getImages
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js